import React from 'react';
import Card from './CardParcelasSelecionadas';
import { Container } from './styles';

import DiscountTextAdvancedPayment from '../../../DiscountTextAdvancedPayment';

const ParcelasSelecionadas = ({ parcelasSelecionadas, tema, loading }) => {
  return (
    <Container tema={tema}>
      <div className='listagemParcelasSelecionadas'>
        <div>
          <div className='tituloContainer'>
            <span className='titulo'>Parcelas selecionadas: </span>
            <span className='parcelasEmAberto'>
              {parcelasSelecionadas?.length.toString().padStart(2, 0)}{' '}
              parcela(s) em aberto
            </span>
          </div>

          <div className={'containerParcelas'}>
            {parcelasSelecionadas.map((parcela, index) => {
              return (
                <div key={index}>
                  <Card parcela={parcela} index={index} tema={tema} />
                </div>
              );
            })}
          </div>
          <p className='textoInformativo'>
            *O boleto vai ser gerado com a soma e desconto(s) aplicados às
            parcelas selecionadas.
          </p>
        </div>
        <DiscountTextAdvancedPayment
          hide={loading}
          parcelas={parcelasSelecionadas}
        />
      </div>
    </Container>
  );
};

export default ParcelasSelecionadas;
